export const environment = {
  production: false,

  LOCAL_SERVER_PORT: 4000,
  API_URL_FOR_LOCAL_SERVER: 'https://linkworx.totalapi.io/api/',

  //API_URL: 'https://localhost:44379/api/'
  API_URL: '/api/'
};
